module.exports = __webpack_public_path__ + "media/images/category_icons/mobile_apps-e73ddbe1128914c8879b4fa93c910b3e.svg";